module.exports = __webpack_public_path__ + "assets/img/ExtractTen_btn.159a865b.png";